import detectTouch from './utils/detect-touch';
import detectBreakpoint from './utils/detect-breakpoint';
import money from './utils/money';
import handleize from './utils/handleize';
import escape from './utils/escape';
import file from './utils/file';
import debounce from './utils/debounce';
import serialize from './libs/serialize';
import cart from './components/cart';
import miniCart from './components/mini-cart';
import accordion from './components/accordion';
import modal from './components/modal';
import searchBar from './components/search-bar';
import variant from './components/variant';
import tooltip from './components/tooltip';
import popup from './components/popup';
import swatches from './components/swatches';
import product from './components/product';
import filter from './components/filter';
import mediumZoom from './libs/medium-zoom';
import header from './components/header';
import menuEventContent from './components/menu-event-content';
import quantitySelector from './components/quantity-selector';
import tooltipHover from './components/tooltip-hover';
import priceList from './components/price-list';
import sizeGuide from './components/size-guide';
import removeFormatting from './components/remove-formatting';


//
//  Global theme variables
//  _____________________________________________

/**
 * Main theme object
 * 
 * @global
 */
window.theme = window.theme || {};

/**
 * Theme scripts to load programmatically
 * 
 * @global
 */
window.theme.script = window.theme.script || {};

/**
 * Shopify file url
 * 
 * @global
 */
window.theme.file_url = window.theme.file_url || {};

/**
 * Current product data - Only available on product page
 * 
 * @global
 */
window.theme.currentProduct =  window.theme.currentProduct || {};

//
//  Utils
//  _____________________________________________

detectTouch.init();
detectBreakpoint.init();
money.init();
escape.init();
file.init();
debounce.init();
handleize.init();

//
//  Libs
//  _____________________________________________

serialize.init();
mediumZoom.init();

//
//  Components
//  _____________________________________________

cart.init();
miniCart.init();
quantitySelector.init();
modal.init();
searchBar.init();
accordion.init();
variant.init();
tooltip.init();
popup.init();
product.init();
swatches.init();
filter.init();
header.init();
tooltipHover.init();
priceList.init();
sizeGuide.init();
removeFormatting.init();

